import Card from '@mui/material/Card';
import { alpha, styled } from '@mui/material/styles';

/** Card in a choice grid: thin divider outline, or a thick brand outline over a pale brand tint while selected. */
export const TintedChoiceCard = styled(Card, {
  shouldForwardProp: prop => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  border: selected
    ? `2px solid ${theme.palette.primary.main}`
    : `1px solid ${theme.palette.divider}`,
  backgroundColor: selected
    ? alpha(theme.palette.primary.main, 0.04)
    : theme.palette.background.paper,
}));
